// material-ui
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';

// project imports
import ContainerWrapper from 'components/ContainerWrapper';
import Logo from 'components/logo';

// ==============================|| FOOTER - AUTHENTICATION ||============================== //
// CodedThemes/MUI Terms & Privacy links removed - not relevant to do-ra.cz
// (and pointed at an unrelated third party's legal pages).

export default function AuthFooter() {
  return (
    <ContainerWrapper>
      <Stack direction="row" sx={{ alignItems: 'center', justifyContent: 'center', gap: 0.625, py: 2, opacity: 0.65 }}>
        <Typography variant="caption" sx={{ color: 'text.secondary', lineHeight: 1 }}>
          &copy;
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', '& svg': { width: 44, height: 9 } }}>
          <Logo to="/" />
        </Box>
        <Typography variant="caption" sx={{ color: 'text.secondary', lineHeight: 1 }}>
          2017–{new Date().getFullYear()}
        </Typography>
      </Stack>
    </ContainerWrapper>
  );
}
